// 学校专区
export default {
    path: "/school",
    name: "school",
    component: () => import("@/views/school/index"),
    children: [
        {
            path: "/school",
            name: "schoolIndex",
            component: () => import("@/views/school/index/index")
        },
        {
            path: "/school/honoraryAward/:id",
            name: "school-honoraryAward-id",
            component: () => import("@/views/school/honoraryAward")
        },
        {
            path: "/school/detail/:id",
            name: "school-detail-id",
            component: () => import("@/views/school/detail")
        },
        {
            path: "/school/qualityClassroom/:id",
            name: "school-qualityClassroom-id",
            component: () => import("@/views/school/qualityClassroom")
        },
        {
            path: "/school/famousTeacher/:schoolId/:teacherId",
            name: "school-famousTeacher-schoolId-teacherId",
            component: () => import("@/views/school/famousTeacher")
        },
        {
            path: "/school/courseware/:id",
            name: "school-courseware-id",
            component: () => import("@/views/school/courseware")
        },
        {
            path: "/school/academicAchievement/:id",
            name: "school-academicAchievement-id",
            component: () => import("@/views/school/academicAchievement")
        },
        // {
        //   path: "/school/campusCulture/:id",
        //   name: "school-campusCulture-id",
        //   component: () => import("@/views/school/campusCulture"),
        //   children: [
        //     {
        //       path: "/school/campusCulture/:id",
        //       name: "school-campusCulture-schoolId",
        //       component: () => import("@/views/school/campusCulture/index/index"),
        //     },
        //     {
        //       path: "/school/campusCulture/detail/:id/:detailId",
        //       name: "school-campusCulture-detail-id-detailId",
        //       component: () => import("@/views/school/campusCulture/detail"),
        //     },
        //   ]
        // },
    ]
}